import { render } from "./recommend_pc_item_details.vue?vue&type=template&id=cbb08668"
import script from "./recommend_pc_item_details.vue?vue&type=script&lang=js"
export * from "./recommend_pc_item_details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__